import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { AuthService } from "../../../shared/services/auth.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { HttpService } from "../../../../http.service";
import { IFilter } from "../../../shared/interfaces/filter.interface";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class DeliveryNotesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) { }

  getDeliveryNotes(filter?: IFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_DELIVERY_NOTES)}${queryParams}`);
  }

  getDeliveryNote(DeliveryNote: any | string): Observable<any> {
    let id = (typeof DeliveryNote == 'string') ? DeliveryNote : DeliveryNote._id;
    return this._http.get(`${apiURL(EnvConfig.API_DELIVERY_NOTES)}/${id}`);
  }

  getDeliveryNotePDFURL(DeliveryNote: any): string {
    let id = (typeof DeliveryNote == 'string') ? DeliveryNote : DeliveryNote._id;
    return `${apiURL(EnvConfig.API_DELIVERY_NOTES)}/${id}/generatePDF`
  }

  getDeliveryNotePDF(DeliveryNote: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = this.getDeliveryNotePDFURL(DeliveryNote);
      this._http.get(url, { responseType: "arraybuffer" }).subscribe(file => {
        resolve(this._utilsService.blobToObjectURL(file, "application/pdf"));
      });
    });
  }

  download(id?: string, name: string = 'albarán') {
    let query = { "company": this._AuthService.companyId() }
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_DELIVERY_NOTES)}/${id}/generatePdf${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
      this._utilsService.blobToFile(file, "application/pdf", name + '.pdf');
    });
  }

  sendEmail(id?: string, data?: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_DELIVERY_NOTES)}/${id}/sendEmail`, data);
  }

  requestSignature(id?: string, data?: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_DELIVERY_NOTES)}/${id}/sendEmail/signature`, data);
  }

  createDeliveryNote(note: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_DELIVERY_NOTES)}`, note);
  }
}